import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';

@Component({
  selector: 'app-apps-library',
  templateUrl: './apps-library.component.html',
  styleUrls: ['./apps-library.component.scss']
})
export class AppsLibraryComponent {

  isFunctionsActive: boolean = false;

  items = [
    {
      colorClass: "light-blue",
      title: "Blog Outline Generator",
      description: "魅力的な見出しと要約で<br/>ブログ執筆のプロセスを<br/>効率化",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["General", "Marketing"]
    },
    {
      colorClass: "light-yellow",
      title: "Blog Topic Idea Generator",
      description: "ターゲット層に向けた<br/>特定分野のブログトピックの<br/>候補を生成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["General", "Marketing"]
    },
    {
      colorClass: "light-green",
      title: "Ad Copy Generator",
      description: "訴求力のある英語のコピー<br/>（広告文案）を作成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["General", "Marketing"]
    },
    {
      colorClass: "light-red",
      title: "SEO Optimized Blog Post Writer",
      description: "SEO対策用のブログ記事を<br/>読みやすい文章で作成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["General", "Marketing"]
    },
    {
      colorClass: "light-cyan",
      title: "Email Subject Line Generator",
      description: "素案から、メール件名の候補を<br/>10種類の表現で生成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["General", "Marketing"]
    },
    {
      colorClass: "light-purple",
      title: "Blog Builder",
      description: "見出しのアイデアの入力で、<br/>ブログのアウトライン・要点・<br/>記事全体を生成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["General", "Marketing"]
    },
    {
      colorClass: "light-blue",
      title: "Manuscript Blog Builder",
      description: "論文原稿を、一般に向けた<br/>分かりやすいブログ記事に変換",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-yellow",
      title: "Paper Title Ideas Generator",
      description: "論文原稿の内容に合致した<br/>説得力のあるタイトルを生成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Ideation"]
    },
    {
      colorClass: "light-green",
      title: "Argument Analyzer",
      description: "論証（Argument）の<br/>強みと弱みを特定",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Critical thinking"]
    },
    {
      colorClass: "light-red",
      title: "Counter Argument Generator",
      description: "強力な反論（Counterargument）を<br/>生成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Critical thinking"]
    },
    {
      colorClass: "light-cyan",
      title: "Analogy Generator",
      description: "説明や論証を強化する<br/>効果的な類比（Analogy）を生成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Critical thinking"]
    },
    {
      colorClass: "light-purple",
      title: "Critique Writer",
      description: "研究論文、理論、文脈、論証などに対する<br/>批判的評価を生成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Critical thinking"]
    },
    {
      colorClass: "light-blue",
      title: "Abstract Rewriter",
      description: "学術論文・論文原稿の要旨（Abstract）を<br/>強化・洗練",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Content"]
    },
    {
      colorClass: "light-yellow",
      title: "Example Generator",
      description: "読み手の理解を促す<br/>分かりやすい具体例を生成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Content"]
    },
    {
      colorClass: "light-green",
      title: "Conclusion Writer",
      description: "研究成果について、<br/>簡潔でインパクトある結論を生成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Content"]
    },
    {
      colorClass: "light-red",
      title: "Key Insights Generator",
      description: "研究の結果および結論についての<br/>実践的なヒントの生成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Analytics"]
    },
    {
      colorClass: "light-cyan",
      title: "Literature Summarizer",
      description: "指定した研究文献の要約を生成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Summary"]
    },
    {
      colorClass: "light-purple",
      title: "Plain Language Summary",
      description: "研究論文を広く理解される<br/>レイサマリーを作成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Summary"]
    },
    {
      colorClass: "light-blue",
      title: "Citation Booster",
      description: "研究成果から<br/>ソーシャルメディアで共有可能な投稿文を<br/>生成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Visibility"]
    },
    {
      colorClass: "light-yellow",
      title: "Keywords Generator",
      description: "研究論文の内容を元に<br/>関連性の高いキーワードを生成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Visibility"]
    },
    {
      colorClass: "light-green",
      title: "Customer Review Response Generator",
      description: "顧客・利用者の意見に対し、<br/>ブランド価値を維持する返答文を作成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["General", "Support"]
    },
    {
      colorClass: "light-red",
      title: "Press Release from Manuscript",
      description: "メディアに取り上げられやすい<br/>研究のプレスリリースを作成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-cyan",
      title: "LinkedIn Post from Manuscript",
      description: "論文原稿から<br/>専門家の目を引くLinkedInの投稿文を作成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-purple",
      title: "Poster Outline from Manuscript",
      description: "論文原稿から<br/>学会発表用ポスターのアウトラインを作成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-blue",
      title: "Audio/Video Script Outline from Manuscript",
      description: "論文原稿をもとに、音声や動画で<br/>研究成果を紹介するための台本を作成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-yellow",
      title: "ResearchGate Content from Manuscript",
      description: "ResearchGate向けの<br/>論文の要約を作成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-green",
      title: "Cover Letter from Abstract",
      description: "論文の要旨（Abstract）を元に、<br/>ジャーナル投稿用カバーレターを生成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-red",
      title: "Tweetable Abstract from Abstract",
      description: "研究を簡潔に紹介するための<br/>Xの投稿文を作成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-cyan",
      title: "Instagram Post from Cover Letter",
      description: "論文投稿時のカバーレターからInstagramの投稿文を作成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-purple",
      title: "Researcher Profile Summarizer",
      description: "研究者プロフィールから<br/>経歴の要約を生成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-blue",
      title: "Thank you Note Creator",
      description: "相手に対する感謝の気持ちを伝える<br/>謝辞の文面を作成",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["General", "Communication"]
    },
    {
      colorClass: "light-yellow",
      title: "Tone Modifier",
      description: "希望のトーンで<br/>コンテンツをリライト",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["General", "Communication"]
    },
  ];

  selectedFilter = 'All';
  selectedSubFilter: string | null = null;
  originalScrollPosition: number = 0;
  //filteredItems = [...this.items];

  @ViewChild('contentContainer', { static: false }) contentContainer: ElementRef | undefined;

  saveScrollPosition() {
    if (this.contentContainer) {
      this.originalScrollPosition = this.contentContainer.nativeElement.scrollTop;
    }
  }

  filterItems(filter: string) {
    this.selectedFilter = filter;
    this.selectedSubFilter = null;
    if (this.contentContainer) {
      this.contentContainer.nativeElement.scrollTop = this.originalScrollPosition;
    }
  }

  filterSubItems(subFilter: string) {
    this.selectedSubFilter = this.selectedSubFilter === subFilter ? null : subFilter;
  }
  
  isSubFilterActive(subFilter: string): boolean {
    return this.selectedSubFilter === subFilter;
  }

  get filteredItems() {
    return this.items.filter(item =>
      (this.selectedFilter === 'All' || item.category.includes(this.selectedFilter)) &&
      (!this.selectedSubFilter || item.category.includes(this.selectedSubFilter))
    );
  }

  toggleSubFilter() {
    this.isFunctionsActive = !this.isFunctionsActive;
  }

  closeFunctionsMenu(): void {
    this.isFunctionsActive = false;
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event): void {
    const target = event.target as HTMLElement;
    const isInsideMenu = target.closest('.sub-menu-filter, .md-function-btn');
    if (!isInsideMenu) {
      this.closeFunctionsMenu();
    }
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

}
